import { io } from 'socket.io-client';
import UniversalCookie from 'universal-cookie';
import { BASEURL } from '/config.js';
import { HEADERS } from '../api/constants.js';
const cookies = new UniversalCookie();
const cookieToken = () => cookies.get('token');

const _socket = io(BASEURL, {
  transports: ['websocket'],
  secure: true,
  rejectUnauthorized: false,
  query: {
    [HEADERS.ACCESS_TOKEN]: cookieToken(),
  },
});

// Debug logging for all socket events
// These can stay since we have the console log removing during the building and these ware helpful for socket event debugging
_socket.onAny((event, ...args) => {
  console.log('[SOCKET] Event received:', event, ...args);
});

_socket.on('connect', () => {
  console.log('[SOCKET] Connected:', _socket.id);
});

_socket.on('join_success', data => {
  console.log('[SOCKET] Successfully joined room:', data);
});

_socket.on('test_echo_response', data => {
  console.log('[SOCKET] Received test echo response:', data);
});

_socket.on('disconnect', reason => {
  console.log('[SOCKET] Disconnected:', reason);
});

_socket.on('connect_error', err => {
  console.error('[SOCKET] Connection error:', err);
});

_socket.connect();

export default _socket;
